
import React from "react";
import logo from '../../icons/icon_2_64.png'
import text_light from '../../icons/text_light.png'
import text_dark from '../../icons/text_dark.png'
import './main-logo.css';

const MainLogoLight = () => (
    <span>
        <img src={logo} height={50} alt="logo" className="logo__img"/>
        <img src={text_light} alt="Darshana"/>
    </span>
);

const MainLogoDark = () => (
    <span>
        <img src={logo} height={50} alt="logo" className="logo__img"/>
        <img src={text_dark} alt="Darshana"/>
    </span>
);

class MainLogo {
    light: any;
    dark: any;

    constructor(light: any, dark: any) {
        this.light = light;
        this.dark = dark;
    }
}

const mainLogo = new MainLogo(MainLogoLight, MainLogoDark);

export default mainLogo;